export default "__VITE_ASSET__9be296a2__"